export default __webpack_public_path__ + "static/media/03.79faa337.jpg";